var _rect, _rect2, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTremor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    transform: "translate(2 2)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 38.6666C29.824 38.6666 36.1667 32.4483 36.1667 24.7777V15.5184C36.1667 13.9843 34.8982 12.7407 33.3333 12.7407C31.7685 12.7407 30.5 13.9843 30.5 15.5184V9.96288C30.5 8.42876 29.2315 7.1851 27.6667 7.1851C26.1019 7.1851 24.8333 8.42876 24.8333 9.96288V8.11103C24.8333 6.57691 23.5648 5.33325 22 5.33325C20.4352 5.33325 19.1667 6.57691 19.1667 8.11103V9.96288C19.1667 8.42876 17.8982 7.1851 16.3333 7.1851C14.7685 7.1851 13.5 8.42876 13.5 9.96288V21.074C13.5 19.5399 12.2315 18.2962 10.6667 18.2962C9.10187 18.2962 7.83334 19.5399 7.83334 21.074V24.7777C7.83334 32.4483 14.176 38.6666 22 38.6666Z",
    fill: "#F1BEED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 21.074V25.7036M13.5 21.074V9.96288C13.5 8.42876 14.7685 7.1851 16.3333 7.1851C17.8982 7.1851 19.1667 8.42876 19.1667 9.96288M13.5 21.074C13.5 19.5399 12.2315 18.2962 10.6667 18.2962C9.10187 18.2962 7.83334 19.5399 7.83334 21.074V24.7777C7.83334 32.4483 14.176 38.6666 22 38.6666C29.824 38.6666 36.1667 32.4483 36.1667 24.7777V15.5184C36.1667 13.9843 34.8982 12.7407 33.3333 12.7407C31.7685 12.7407 30.5 13.9843 30.5 15.5184M19.1667 9.96288V20.1481M19.1667 9.96288V8.11103C19.1667 6.57691 20.4352 5.33325 22 5.33325C23.5648 5.33325 24.8333 6.57691 24.8333 8.11103V9.96288M24.8333 9.96288V20.1481M24.8333 9.96288C24.8333 8.42876 26.1019 7.1851 27.6667 7.1851C29.2315 7.1851 30.5 8.42876 30.5 9.96288V15.5184M30.5 15.5184V20.1481",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33604 10.2227L6.72292 10.8572L7.63376 12.2137L5.98011 12.7717L6.79518 14.1836L5.34044 14.751L6.25187 16.1063",
    stroke: "black",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0491 4.24819L36.7714 4.4436L36.2427 5.98956L37.9845 6.10062L37.5626 7.67529L39.1146 7.84691L38.585 9.39191",
    stroke: "black",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34 39.0533L35.7143 39.3103L35.6037 37.6802L37.3148 38.0237L37.3149 36.3935L38.8584 36.6294L38.7468 35",
    stroke: "black",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTremor);
export default __webpack_public_path__ + "static/media/tremor.cdee6f662680d0f1b6ee5236526b2001.svg";
export { ForwardRef as ReactComponent };